export const routes = {
  home: '/',
  pricing: '/pricing',
  cvFeature: '/features/cv-builder',
  linkedinFeature: '/features/linkedin-checker',
  interviewFeature: '/features/interview-prep',
  privacy: '/privacy',
  terms: '/terms',
  login: '/login',
  register: '/register',
  adminLogin: '/admin/login',
  passwordSetup: '/set-password',
  purchaserClaim: '/claim',
  formEnglish: '/form/en',
  formArabic: '/form/ar',
  onboarding: '/onboarding',
  app: '/app',
  intake: '/app/intake',
  profile: '/app/profile',
  cv: '/app/cv',
  cvCheck: '/app/cv-check',
  linkedin: '/app/linkedin',
  jobs: '/app/jobs',
  interview: '/app/interview',
  account: '/app/account',
  admin: '/app/admin',
} as const;

export function publicIntakeForm(id: string): string {
  return `/form/${encodeURIComponent(id)}`;
}

export function purchaserClaimPath(token: string): string {
  return `${routes.purchaserClaim}/${encodeURIComponent(token)}`;
}

export function safeReturnTo(value: string | null, fallback: string = routes.app): string {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return fallback;
  return value;
}
